import React from 'react';

export default function Footer() {
  return (
    <footer style={{
      backgroundColor: '#f7f9fb',
      padding: '2rem',
      textAlign: 'center',
      borderTop: '1px solid #e0e0e0',
      marginTop: 'auto'
    }}>
      <p style={{
        margin: 0,
        color: '#666',
        fontSize: '0.9rem'
      }}>
        © 2025 Honor Society Tutors, Inc. All Rights Reserved.
      </p>

<div style={{ marginTop: '1rem' }}>
  <a
    href="/privacy-policy"
    style={{ color: '#04d664', textDecoration: 'none', marginRight: '1rem', fontWeight: '600' }}
  >
    Privacy Policy
  </a>
  <a
    href="/terms-of-use"
    style={{ color: '#04d664', textDecoration: 'none', fontWeight: '600' }}
  >
    Terms of Use
  </a>
</div>

    </footer>
  );
}
